export default {
  name: 'Menu',
  props: {
    menuList: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      classCurrentIndex: 0,
      hasMenu: false,
      menu_pro: {
        parent: 0,
        son: -1
      }
    }
  },
  computed: {
    classIndex: {
      set() {},
      get() {
        return this.hasMenu ? this.menu.parent : this.classCurrentIndex;
      }
    },
    menu: {
      set() {},
      get() {
        let menu_pro = {
          parent: 0,
          son: -1
        }
        let _this = this;
        this.menuList.forEach((item, index) => {
          item.style = {
            'background': 'url(../../../../static/img/' + item.function_icon + '.svg) 0% 0% / 100% 100% no-repeat',
          }
          if (item.children && item.children.length > 0) {
            item.children.forEach((subitem, subindex) => {
              subitem.style = {
                'background': 'url(../../../../static/img/' + subitem.function_icon + '.svg)  0% 0% / 100% 100% no-repeat',
              }
              this.$route.matched.forEach(t => {
                if (subitem.function_url === t.path) {
                  menu_pro.parent = index;
                  menu_pro.son = subindex;
                  _this.hasMenu = true;
                }
              });
            });
          } else {
            let is_has = false;

            this.$route.matched.forEach(t => {
              if (item.function_url === t.path) {
                is_has = true;
              }
            })
            if (is_has) {
              menu_pro.parent = index;
              _this.hasMenu = true;
            }
          }
        });
        return menu_pro;
      }
    }
  },
  methods: {
    setParentTag(flag) {
      this.hasMenu = false;
      if (this.classCurrentIndex == flag) {
        this.classCurrentIndex = flag + '0'
      } else {
        this.classCurrentIndex = flag;
      }
    },
    setTag(parentIndex, index) {
      this.menu = {
        parent: parentIndex,
        son: index ? index : 0
      }
    },
    exitSystem() {
      this.$axios.get('/auth/out', {
          baseURL: this.$api_site.AUTHSITE + "/api/v1"
        })
        .then((data) => {
          if (data.success) {
            window.location.href = "index.html#/login";
          } else {
            this.$Message.info(data.msg);
          }
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/common/menu/main.js